/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from 'axios';
import { AnyAction } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { displayToast } from '../redux/toast/toastSlice';
import { watchList } from '../redux/toast/watchList';

export type ErrorType = {
 title?: string;
 message?: string;
 type?: 'error' | 'warning' | 'info' | 'success';
};

export function isAxiosError(candidate: unknown): candidate is AxiosError {
 if (
  candidate &&
  typeof candidate === 'object' &&
  'isAxiosError' in candidate
 ) {
  return true;
 }
 return false;
}

export function* errorHandling(
 error: unknown | AxiosError,
 callback?: (payload: ErrorType) => AnyAction,
) {
 console.log(error);
 let output = '';
 let title = '';
 if (isAxiosError(error) || error instanceof AxiosError) {
  let message = error?.message ?? '';
  const responseData = error?.response?.data as
   | { title?: string }
   | null
   | undefined;

  if (responseData) {
   message = `${message}\r\n${JSON.stringify(responseData)}`;
  }
  if (responseData?.title) {
   message = `<span style="font-weight: bold; font-size: 16px; display:block;margin-bottom: 8px;">${responseData.title}</span>${error?.message ?? ''}`;
  }

  const configUrl = error?.config?.url;
  const baseURL = error?.config?.baseURL;
  const fullUrl =
   baseURL && configUrl ? `${baseURL}${configUrl}` : configUrl || baseURL;

  if (fullUrl) {
   message = `${message}\r\n${fullUrl}`;
  }

  output = message;
  title = responseData?.title ?? '';
 } else {
  output = `Unknown error: ${
   typeof error === 'object' ? error : JSON.stringify(error)
  }`;
  title = 'Unknown error';
 }

 if (!callback) {
  yield put(
   displayToast({
    message: output,
    type: 'error',
   }),
  );
  return;
 }

 const isCallbackInWatchList = (
  watchList as unknown as Array<(payload: ErrorType) => AnyAction>
 ).includes(callback);

 if (!isCallbackInWatchList) {
  yield put(
   displayToast({
    message: output,
    type: 'error',
   }),
  );
  return;
 }

 yield put(
  callback({
   title,
   message: output,
   type: 'error',
  }),
 );
}
